import BootstrapVue from 'bootstrap-vue';
import Vue from 'vue';
import {datePick} from "./libs/datepick/datepick";
import moment from 'moment';

window.Vue = Vue;
window.moment = moment;
Vue.use(BootstrapVue);
Vue.filter('formatDate', function(value) {
	if (value) {
		return moment(String(value)).format('DD/MM/YYYY')
	}
});


import VueTheMask from 'vue-the-mask';
Vue.use(VueTheMask);


window.VueScrollTo = require('vue-scrollto');
Vue.use(VueScrollTo);

Vue.mixin({
	methods: {

		get_datepickLang() {
			return datePick.lang;
		},

		obj_to_null(someObject) {
			if (someObject == null) {
				return null;
			}

			let res = Object.keys(someObject).length;

			if (res === 0) {
				return null;
			}
			return someObject;
		},

		curdate : function (format,callback) {
			api.get('/srv_time/' + format,).then(({data}) => {
				callback(data.data);
			}).catch(err => {
				console.error(err);
			});
		},

		re_map_text : function (item,type) {
			if(item.isPrototypeOf(String)) {
				return item;
			}
			else {
				if(type === 'label') {
					return item.label;
				}

				if(type === 'text') {
					return item.text;
				}
			}
		},
	},

	filters: {

		format_price: function (value) {
			let  opts = { minimumFractionDigits: 2 };
			return  value.toLocaleString(undefined,opts);
		},




		uppercase: function (value) {
			if (!value) return ''
			value = value.toString()
			return value.toUpperCase()
		},

		get_image_from_template(img, width, height, type = 'webp') {
			if (img.length > 0) {
				return img
					.replace("{webp|jpeg|png}", type)
					.replace("{width}", width)
					.replace("{height}", height);
			}
			return "";
		},

	},
});

Vue.filter('toNiceNumber', function (value) {
	if (typeof value !== "number") {
		value = parseFloat(value);
	}

	let formatter = new Intl.NumberFormat('ru-Ru', {
		// style: 'currency',
		//  currency: 'UAH',
		minimumFractionDigits: 2
	});
	return formatter.format(value).replace(".",'');
});